import React from "react";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import BreadCrumb from '../../components/BreadCrumb';

const ProjectMaintenance = () => {
    return (
        <div>
            <Navbar />
                <div class="container">
                    <BreadCrumb 
                        active_page="Project Maintenance" 
                        prev_sub_page={{
                            'link':'/services',
                            'text':'Services'
                        }}
                        sub_page={{
                            'link':'/services/it-development-consulting',
                            'text':'IT Development & Consulting'
                        }} 
                    />
                    <div class="inner-container">
                        <h2>Project Maintenance</h2>
                        <h3>Business Continuity</h3>
                        <p>Project maintenance is as important as project planning & a most overlooked factor in project success. We periodically assess the application to ensure its smooth functioning.</p>
                        <img alt="" src={require('../../assets/images/services/application-maintainance.png')} width="100%"/>
                        <div className="row mt-5">
                            <div className="col-md-6">
                                <h3>Services</h3>
                                <ul>
                                    <li>Server Migration</li>
                                    <li>Bug Fixes & Task Tracking</li>
                                    <li>Upgrades & Enhancement</li>
                                    <li>Application re-engineering</li>
                                    <li>Hybrid App Integration Services</li>
                                </ul>
                            </div>
                            <div className="col-md-6">
                                <h3>Why Choose Us</h3>
                                <ul>
                                    <li>100% Proactive maintenance</li>
                                    <li>0% Downtime</li>
                                    <li>5X Higher Efficiency</li>
                                    <li>100% Customer Satisfaction</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            <Footer />
        </div>
    );
};

export default ProjectMaintenance;